<script>
import useSharedData from "@/use/SharedData";

export default {
  props: {
    vertical: Boolean
  },
  setup() {
    const { backgroundColor } = useSharedData();

    return {
      backgroundColor
    };
  }
};
</script>

<template>
  <v-tabs
    class="tabs"
    color="teal"
    :background-color="backgroundColor"
    :vertical="vertical"
    slider-size="7"
  >
    <slot></slot>
  </v-tabs>
</template>

<style lang="scss" scoped>
div.tabs [role="tab"] {
  justify-content: flex-start;
}
</style>